import React, { ChangeEvent, useEffect, useState, CSSProperties } from "react";

// import { getUniqueKey } from "@react-sigma/core/lib/utils";
import { useSigma } from "@react-sigma/core";
import { useCamera } from "@react-sigma/core";
// import { useRegisterEvents } from "../../hooks/useRegisterEvents";
import { useRegisterEvents } from "@react-sigma/core";
import { AutocompleteStoryInput } from "./AutocompleteStory";
import { useAtomValue, useSetAtom } from "jotai";
import { graphSearchSelectionState } from "./JotaiAtoms";

export function getUniqueKey() {
  return Math.random().toString(36).slice(2);
}

type GraphEdge = [string, string];

export type GraphData = {
  edges: GraphEdge[];
  nodes: { [storyId: string]: [number, string] };
};

/**
 * Headless component that watches the graphSearchSelectionState atom
 * and navigates the camera to the selected node. Must be inside SigmaContainer.
 */
export const GraphSearchControl = ({ data }: { data?: GraphData }) => {
  const sigma = useSigma();
  const registerEvents = useRegisterEvents();
  const { gotoNode } = useCamera();
  const selectedNodeId = useAtomValue(graphSearchSelectionState);
  const setSelectedNodeId = useSetAtom(graphSearchSelectionState);

  // Clear selection when data changes
  useEffect(() => {
    setSelectedNodeId("");
  }, [data, setSelectedNodeId]);

  // Clear selection when stage is clicked
  useEffect(() => {
    registerEvents({
      clickStage: () => {
        setSelectedNodeId("");
      },
    });
  }, [registerEvents, setSelectedNodeId]);

  // Navigate to selected node
  useEffect(() => {
    if (!selectedNodeId) {
      return;
    }

    try {
      sigma.getGraph().setNodeAttribute(selectedNodeId, "highlighted", true);
      gotoNode(selectedNodeId);

      return () => {
        try {
          sigma.getGraph().setNodeAttribute(selectedNodeId, "highlighted", false);
        } catch (e) {}
      };
    } catch (e) {
      return;
    }
  }, [selectedNodeId, sigma, gotoNode]);

  // Headless - no UI
  return null;
};
